function loadAssets(scripts, styles, action){
    window.addEventListener("load", function(){
      var filesloaded = 0;
      var filestoload = scripts.length + styles.length;
      if(styles.length > 0){
        for (var i = 0; i < styles.length; i++) {
            var style = document.createElement('link');
            style.rel = 'stylesheet';
            style.href = styles[i];
            style.type = 'text/css';
            style.onload = function () {
                filesloaded++;
                finishLoad();
            };
            document.head.appendChild(style);
        }
      }
      if(scripts.length > 0){
        for (var i = 0; i < scripts.length; i++) {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = scripts[i];
            script.onload = function () {
                filesloaded++;
                finishLoad();
            };
            document.head.appendChild(script);
        }
      }
      
      function finishLoad() {
          if (filesloaded === filestoload) {
              actionOnLoad(action);
          }
      }
    });
  }
  
  function actionOnLoad(action){
    
    if(action == 'ratting-snippet'){
      ratingSnippet("ruk_rating_snippet",{
          store: "bodyheal-com-au",
          color: "#edaf05",
          linebreak: false
      });
      ratingSnippet("ruk_rating_snippet_product",{
          store: "bodyheal-com-au",
          color: "#edaf05",
          linebreak: false,
          text: "Reviews"
      });
    }
  
    
    if(action == 'reviewsio-carousel'){
      new carouselInlineWidget('reviewsio-carousel-widget',{
          /*Your REVIEWS.io account ID:*/
          store: 'bodyheal-com-au',
          sku: '',
          lang: 'en',
          carousel_type: 'topHeader',
          styles_carousel: 'CarouselWidget--topHeader--withcards',
    
          /*Widget settings:*/
          options:{
            general:{
              /*What reviews should the widget display? Available options: company, product, third_party. You can choose one type or multiple separated by comma.*/
              review_type: 'company',
              /*Minimum number of reviews required for widget to be displayed*/
              min_reviews: '1',
              /*Maximum number of reviews to include in the carousel widget.*/
              max_reviews: '20',
              address_format: 'CITY, COUNTRY',
              /*Carousel auto-scrolling speed. 3000 = 3 seconds. If you want to disable auto-scroll, set this value to false.*/
              enable_auto_scroll: 10000,
            },
            header:{
              /*Show overall rating stars*/
              enable_overall_stars: true,
            },
            reviews: {
              /*Show customer name*/
              enable_customer_name: true,
              /*Show customer location*/
              enable_customer_location: true,
              /*Show "verified review" badge*/
              enable_verified_badge: true,
              /*Show "I recommend this product" badge (Only for product reviews)*/
              enable_recommends_badge: true,
              /*Show photos attached to reviews*/
              enable_photos: true,
              /*Show videos attached to reviews*/
              enable_videos: true,
              /*Show when review was written*/
              enable_review_date: true,
              /*Hide reviews written by the same customer (This may occur when customer reviews multiple products)*/
              disable_same_customer: true,
              /*Minimum star rating*/
              min_review_percent: 4,
              /*Show 3rd party review source*/
              third_party_source: true,
              /*Hide reviews without comments (still shows if review has a photo)*/
              hide_empty_reviews: true,
              /*Show product name*/
              enable_product_name: true,
              /*Show only reviews which have specific tags (multiple comma separated tags allowed)*/
              tags: "",
              /*Show branch, only one input*/
              branch: "",
              enable_branch_name: false,
            },
            popups: {
              /*Make review items clickable (When they are clicked, a popup appears with more information about a customer and review)*/
              enable_review_popups:  true,
              /*Show "was this review helpful" buttons*/
              enable_helpful_buttons: true,
              /*Show how many times review was upvoted as helpful*/
              enable_helpful_count: true,
              /*Show share buttons*/
              enable_share_buttons: true,
            },
          },
          styles:{
            /*Base font size is a reference size for all text elements. When base value gets changed, all TextHeading and TexBody elements get proportionally adjusted.*/
            '--base-font-size': '16px',
            '--base-maxwidth':'100%',
    
            /*Logo styles:*/
            '--reviewsio-logo-style':'var(--logo-normal)',
    
            /*Star styles:*/
            '--common-star-color':'#EDAF05',
            '--common-star-disabled-color':' rgba(0,0,0,0.25)',
            '--medium-star-size':'23px',
            '--small-star-size':'22px', /*Modal*/
            '--x-small-star-size':'20px',
            '--x-small-star-display':'inline-flex',
    
            /*Header styles:*/
            '--header-order':'1',
            '--header-width':'160px',
            '--header-bg-start-color':'transparent',
            '--header-bg-end-color':'transparent',
            '--header-gradient-direction':'135deg',
            '--header-padding':'0.5em',
            '--header-border-width':'0',
            '--header-border-color':'#0000009E',
            '--header-border-radius':'0',
            '--header-shadow-size':'0px',
            '--header-shadow-color':'rgba(0, 0, 0, 0.1)',
    
            /*Header content styles:*/
            '--header-star-color':'rgb(237, 175, 5)',
            '--header-disabled-star-color':'inherit',
            '--header-heading-text-color':'inherit',
            '--header-heading-font-size':'18px',
            '--header-heading-font-weight':'inherit',
            '--header-heading-line-height':'inherit',
            '--header-heading-text-transform':'inherit',
            '--header-subheading-text-color':'inherit',
            '--header-subheading-font-size':'18px',
            '--header-subheading-font-weight':'inherit',
            '--header-subheading-line-height':'inherit',
            '--header-subheading-text-transform':'inherit',
    
            /*Review item styles:*/
            '--item-maximum-columns':'5',/*Must be 3 or larger*/
            '--item-background-start-color':'#FFFFFF00',
            '--item-background-end-color':'#FFFFFF00',
            '--item-gradient-direction':'135deg',
            '--item-padding':'1.5em',
            '--item-border-width':'1px',
            '--item-border-color':'rgba(0,0,0,0.1)',
            '--item-border-radius':'1px',
            '--item-shadow-size':'10px',
            '--item-shadow-color':'rgba(0,0,0,0.05)',
    
            /*Heading styles:*/
            '--heading-text-color':' #0E1311',
            '--heading-text-font-weight':' 600',
            '--heading-text-font-family':' inherit',
            '--heading-text-line-height':'1.6',
            '--heading-text-letter-spacing':'0',
            '--heading-text-transform':'none',
    
            /*Body text styles:*/
            '--body-text-color':' #0E1311',
            '--body-text-font-weight':'400',
            '--body-text-font-family':' inherit',
            '--body-text-line-height':'1.6',
            '--body-text-letter-spacing':'0',
            '--body-text-transform':'none',
    
            /*Scroll button styles:*/
            '--scroll-button-icon-color':'#0E1311',
            '--scroll-button-icon-size':'24px',
            '--scroll-button-bg-color':'transparent',
    
            '--scroll-button-border-width':'0px',
            '--scroll-button-border-color':'rgba(0,0,0,0.1)',
    
            '--scroll-button-border-radius':'60px',
            '--scroll-button-shadow-size':'0px',
            '--scroll-button-shadow-color':'rgba(0,0,0,0.1)',
            '--scroll-button-horizontal-position':'0px',
            '--scroll-button-vertical-position':'0px',
    
            /*Badge styles:*/
            '--badge-icon-color':'#2B69A9',
            '--badge-icon-font-size':'20px',
            '--badge-text-color':'#2B69A9',
            '--badge-text-font-size':'15px',
            '--badge-text-letter-spacing':'inherit',
            '--badge-text-transform':'inherit',
    
            /*Author styles:*/
            '--author-font-size':'16px',
            '--author-font-weight':'inherit',
            '--author-text-transform':'inherit',
    
            /*Product photo or review photo styles:*/
            '--photo-video-thumbnail-size':'60px',
            '--photo-video-thumbnail-border-radius':'0px',
    
            /*Popup styles:*/
            '--popup-backdrop-color':'rgba(0,0,0,0.75)',
            '--popup-color':'#ffffff',
            '--popup-star-color':'inherit',
            '--popup-disabled-star-color':'inherit',
            '--popup-heading-text-color':'inherit',
            '--popup-body-text-color':'inherit',
            '--popup-badge-icon-color':'inherit',
            '--popup-badge-icon-font-size':'19px',
            '--popup-badge-text-color':'inherit',
            '--popup-badge-text-font-size':'14px',
            '--popup-border-width':'0px',
            '--popup-border-color':'rgba(0,0,0,0.1)',
            '--popup-border-radius':'0px',
            '--popup-shadow-size':'0px',
            '--popup-shadow-color':'rgba(0,0,0,0.1)',
            '--popup-icon-color':'#0E1311',
    
            /*Tooltip styles:*/
            '--tooltip-bg-color':'#0E1311',
            '--tooltip-text-color':'#ffffff',
          },
      });
    }
  
    
    if(action == 'reviewsio-widget'){
      new ReviewsWidget('#ReviewsWidget', {
        //Your REVIEWS.io account ID and widget type:
        store: 'bodyheal-com-au',
        widget: 'polaris',
  
        //Content settings (store_review,product_review,questions). Choose what to display in this widget:
        options: {
          types: 'product_review,questions',
          lang: 'en',
          //Possible layout options: bordered, large and reverse.
          layout: '',
          //How many reviews & questions to show per page?
          per_page: 10,
          //Product specific settings. Provide product SKU for which reviews should be displayed:
          product_review:{
            //Display product reviews - include multiple product SKUs seperated by Semi-Colons (Main Indentifer in your product catalog )
            sku: script_params_sku,
            hide_if_no_results: false,
          enable_rich_snippets: false,
          },
          //Questions settings:
          questions:{
            hide_if_no_results: false,
            enable_ask_question: true,
            show_dates: true,
            //Display group questions by providing a grouping variable, new questions will be assigned to this group.
            grouping: script_params_sku
          },
  
          //Header settings:
          header:{
            enable_summary: true, //Show overall rating & review count
            enable_ratings: true,
            enable_attributes: true,
            enable_image_gallery: true, //Show photo & video gallery
            enable_percent_recommended: false, //Show what percentage of reviewers recommend it
            enable_write_review: false, //Show "Write Review" button
            enable_ask_question: true, //Show "Ask Question" button
            enable_sub_header: true, //Show subheader
          },
  
          //Filtering settings:
          filtering:{
            enable: true, //Show filtering options
            enable_text_search: true, //Show search field
            enable_sorting: true, //Show sorting options (most recent, most popular)
            enable_overall_rating_filter: true, //Show overall rating breakdown filter
            enable_ratings_filters: true, //Show product attributes filter
            enable_attributes_filters: true, //Show author attributes filter
          },
  
          //Review settings:
          reviews:{
            enable_avatar: false, //Show author avatar
            enable_reviewer_name:  true, //Show author name
            enable_reviewer_address:  true, //Show author location
            reviewer_address_format: 'city, country', //Author location display format
            enable_verified_badge: true, //Show "Verified Customer" badge
            enable_reviewer_recommends: false, //Show "I recommend it" badge
            enable_attributes: true, //Show author attributes
            enable_product_name: true, //Show display product name
            enable_review_title: undefined, //Show review title
            enable_replies: true, //Show review replies
            enable_images: true, //Show display review photos
            enable_ratings: true, //Show product attributes (additional ratings)
            enable_share: true, //Show share buttons
            enable_helpful_vote: true, //Show "was this helpful?" section
            enable_helpful_display: true, //Show how many times times review upvoted
            enable_report: true, //Show report button
            enable_date: true, //Show when review was published
          },
        },
        //Translation settings
        translations: {
          'Verified Customer': 'Verified Buyer',
          'Reply': 'Body Heal replied'
        },
        //Style settings:
        //Style settings:
        styles: {
          //Base font size is a reference size for all text elements. When base value gets changed, all TextHeading and TexBody elements get proportionally adjusted.
          '--base-font-size': '16px',
  
          //Button styles (shared between buttons):
          '--common-button-font-family': 'inherit',
          '--common-button-font-size':'16px',
          '--common-button-font-weight':'500',
          '--common-button-letter-spacing':'0',
          '--common-button-text-transform':'none',
          '--common-button-vertical-padding':'10px',
          '--common-button-horizontal-padding':'20px',
          '--common-button-border-width':'2px',
          '--common-button-border-radius':'0px',
  
          //Primary button styles:
          '--primary-button-bg-color': '#0E1311',
          '--primary-button-border-color': '#0E1311',
          '--primary-button-text-color': '#1D4C8E',
  
          //Secondary button styles:
          '--secondary-button-bg-color': 'transparent',
          '--secondary-button-border-color': '#0E1311',
          '--secondary-button-text-color': '#1d4c8e',
  
          //Star styles:
          '--common-star-color': 'rgb(237, 175, 5)',
          '--common-star-disabled-color': 'rgba(0,0,0,0.25)',
          '--medium-star-size': '22px',
          '--small-star-size': '20px',
  
          //Heading styles:
          '--heading-text-color': '#0E1311',
          '--heading-text-font-weight': '600',
          '--heading-text-font-family': 'inherit',
          '--heading-text-line-height': '1.6',
          '--heading-text-letter-spacing': '0.5px',
          '--heading-text-transform': 'none',
  
          //Body text styles:
          '--body-text-color': '#0E1311',
          '--body-text-font-weight': '400',
          '--body-text-font-family': 'inherit',
          '--body-text-line-height': '1.4',
          '--body-text-letter-spacing': '0.5px',
          '--body-text-transform': 'none',
  
          //Input field styles:
          '--inputfield-text-font-family': 'inherit',
          '--input-text-font-size': '16px',
          '--inputfield-text-font-weight': '400',
          '--inputfield-text-color': '#0E1311',
          '--inputfield-border-color': 'rgba(0,0,0,0.2)',
          '--inputfield-background-color': 'transparent',
          '--inputfield-border-width': '1px',
          '--inputfield-border-radius': '0px',
  
          '--common-border-color': 'rgba(0,0,0,0.15)',
          '--common-border-width': '1px',
          '--common-sidebar-width': '190px',
  
          //Slider indicator (for attributes) styles:
          '--slider-indicator-bg-color': '#4274B8',
          '--slider-indicator-button-color': '#0E1311',
          '--slider-indicator-width': '190px',
  
          //Badge styles:
          '--badge-icon-color': '#6B96D1',
          '--badge-icon-font-size': '20px',
          '--badge-text-color': '#1D4C8E',
          '--badge-text-font-size': '15px',
          '--badge-text-letter-spacing': 'inherit',
          '--badge-text-transform': 'inherit',
  
          //Author styles:
          '--author-font-size': 'inherit',
          '--author-text-transform': 'none',
  
          //Author avatar styles:
          '--avatar-thumbnail-size': '60px',
          '--avatar-thumbnail-border-radius': '100px',
          '--avatar-thumbnail-text-color': '#0E1311',
          '--avatar-thumbnail-bg-color': 'rgba(0,0,0,0.1)',
  
          //Product photo or review photo styles:
          '--photo-video-thumbnail-size': '200px',
          '--photo-video-thumbnail-border-radius': '0px',
  
          //Media (photo & video) slider styles:
          '--mediaslider-scroll-button-icon-color': '#333333',
          '--mediaslider-scroll-button-bg-color': '#ECECEC',
          '--mediaslider-overlay-text-color': '#1F0C0C',
          '--mediaslider-overlay-bg-color': 'rgba(0, 0, 0, 0.8))',
          '--mediaslider-item-size': '150px',
  
          //Pagination & tabs styles (normal):
          '--pagination-tab-text-color': '#0E1311',
          '--pagination-tab-text-transform': 'none',
          '--pagination-tab-text-letter-spacing': '0',
          '--pagination-tab-text-font-size': '16px',
          '--pagination-tab-text-font-weight': '600',
  
          //Pagination & tabs styles (active):
          '--pagination-tab-active-text-color': '#0E1311',
          '--pagination-tab-active-text-font-weight': '600',
          '--pagination-tab-active-border-color': '#0E1311',
          '--pagination-tab-border-width': '3px',
        },
      });
    }
    if(action == 'gorgias-chat'){
      var initGorgiasChatPromise = (window.GorgiasChat) ? window.GorgiasChat.init() : new Promise(function (resolve) { window.addEventListener('gorgias-widget-loaded', function () { resolve();})});

      initGorgiasChatPromise.then(async () => {
        GorgiasChat.hidePoweredBy(true)
        
      })
    }
  
  }

  
  function calculateProgress(currentVal, targetVal) {
      var progressBar = document.querySelectorAll('.cart-shippingThreshold__progress');
      var progressNum = document.querySelectorAll('.cart-shipping__num');
      var progressOuter = document.querySelectorAll('.cart-shipping__numOuter');
      var successMsg = document.querySelectorAll('.cart-shipping__success');
      var shippingThreshold = document.querySelectorAll('.cart-shippingThreshold__bar');
      // calculate how far progress is from the total as a percentage
      var result = Math.round(100 * currentVal / targetVal);
      progressBar.forEach(function(el){
        el.setAttribute('style', "width: ".concat(result, "%"));
      })
       // Update the progess text. If threshold is met, show success message
      var newProgressNum = (targetVal - currentVal) / 100;
      if(newProgressNum <= 0 || currentVal == 0){
        successMsg.forEach(function(el){
          el.style.display = 'block';
        });
        progressOuter.forEach(function(el){
          el.style.display = 'none';
        });
        progressNum.forEach(function(el){
          el.textContent = newProgressNum;
        });
        shippingThreshold.forEach(function(el){
          el.style.display="none"
        });
      
      } else {
     
        successMsg.forEach(function(el){
          el.style.display = 'none';
        });
        progressOuter.forEach(function(el){
          el.style.display = 'block';
        });
        progressNum.forEach(function(el){
          el.textContent = newProgressNum;
        });
        document.querySelectorAll('.cart-shippingThreshold__bar').forEach(function(el){
          el.style.display = 'block';
        })
      }
      document.querySelectorAll('.cart-shipping__wrapper').forEach(function(el){
        el.style.opacity = 1;
      })
  };